import(/* webpackMode: "eager" */ "/vercel/path0/app/speaking/StartExamBtn.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/vercel/path0/public/evaluation.webp");
import(/* webpackMode: "eager" */ "/vercel/path0/public/julia.webp");
import(/* webpackMode: "eager" */ "/vercel/path0/public/speaking.webp");
import(/* webpackMode: "eager" */ "/vercel/path0/public/thinking_man.webp")